import { getURLParams } from 'src/helpers/actions/local/core/local_action_parse_url_helpers';
import {
	CAMERA_DURATION_MAX,
	CAMERA_DURATION_MIN,
	CAMERA_LEGACY_SET_CONFIG_METHOD,
	CAMERA_PLAY_SOUND_METHOD,
	CAMERA_SET_METHOD,
	CAMERA_ZONE_SET_CONFIG_METHOD,
} from 'src/helpers/actions/local/devices/camera_local_actions';
import { isCameraSoundName } from 'src/components/Camera/helpers/camera-sounds';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const validateCameraURLWebhook = (url: string): ActionJob | null => {
	const action: ActionJob = getURLParams(url);
	const config = action.params?.config;
	const method = action.method?.toLowerCase();
	if (method === 'camera.startrecording' && action.params?.duration != null) {
		const duration = action.params.duration;
		action.error =
			action.error ||
			!Number.isSafeInteger(duration) ||
			duration < CAMERA_DURATION_MIN ||
			duration > CAMERA_DURATION_MAX;
	} else if (method === CAMERA_PLAY_SOUND_METHOD) {
		action.error = action.error || !isCameraSoundName(action.params?.sound);
	} else if (method === CAMERA_SET_METHOD) {
		action.error = action.error || (action.params?.arm == null && action.params?.privacy == null);
	} else if (method === CAMERA_LEGACY_SET_CONFIG_METHOD) {
		// LEGACY_CAMERA_ARM_PRIVACY: remove with the old firmware.
		action.error = action.error || !config || (config?.arm == null && config?.privacy == null);
	} else if (method === CAMERA_ZONE_SET_CONFIG_METHOD) {
		action.error = action.error || action.params?.id == null || !config || config?.enable == null;
	}
	return action;
};
